$('.block-testimonial-slider').each(function() {

	const slider = $(this);

	let opts = {
		autoHeight: true,
        keyboard: {
            enabled: true,
        },
		loop: true,
		navigation: {
			nextEl: slider.find('.swiper-arrow.next')[0],
			prevEl: slider.find('.swiper-arrow.prev')[0],
		},
		pagination: {
			clickable: false,
			el: slider.find('.swiper-dots')[0],
		},
        spaceBetween: global_helpers.defaults.slide_spacing,
		speed: 500,
	};

	const swiper = new Swiper($(this).find('.swiper')[0], opts);

});
